module.exports = __webpack_public_path__ + "media/36.a9e6d8e7.mp3";